import React from 'react';
import { Image, theme } from 'antd';
import { API_DOMAIN } from '../../../components/constants';
import { partPhotoSummary } from '../models/photoTags';
import './photo-tags.css';

export function PartPhotoRow({ data, partId }) {
  const { token } = theme.useToken();
  const summary = partPhotoSummary(data, partId);
  if (!summary) return null;
  return <div className="query-part-photo-row" aria-label={`Photos for part ${partId}`}>
    {summary.photos.map(photo => <Image key={photo.image_id} alt="Part photo"
      src={/^https?:/.test(photo.image_id) ? photo.image_id : `${API_DOMAIN}${photo.image_id}`}
      width={40} height={40} style={{ objectFit: 'cover', borderRadius: 4 }} />)}
    {summary.generalCount > 0 && <span style={{ color: token.colorTextSecondary, fontSize: 11 }}>+ {summary.generalCount} general</span>}
  </div>;
}
